import BasicUtils from "./basic-utils";
var _alerts = [];
var _callbacks = [];

var _runCallbacks = function _runCallbacks() {
  return _callbacks.forEach(function (cb) {
    return cb();
  });
};

export var actions = {
  alert: function alert(config) {
    _alerts = _alerts.concat({
      config: config,
      key: config.key || BasicUtils.randomKey()
    });
    return _runCallbacks();
  },
  launchToast: function launchToast(config) {
    this.alert(config);
  },
  removeToast: function removeToast(key) {
    if (key == null) {
      key = undefined;
    }

    _alerts = typeof key === "undefined" ? [] : _alerts.filter(function (alert) {
      return alert.key !== key;
    });
    return _runCallbacks();
  }
};
export var store = {
  getAll: function getAll() {
    return _alerts.slice(0);
  },
  onChange: function onChange(callback) {
    return _callbacks.push(callback);
  },
  clearOnChange: function clearOnChange(callback) {
    return _callbacks = _callbacks.filter(function (cb) {
      return cb !== callback;
    });
  }
};